import { render, staticRenderFns } from "./SpaceImportModal.vue?vue&type=template&id=8b63cba8&scoped=true&"
import script from "./SpaceImportModal.vue?vue&type=script&lang=js&"
export * from "./SpaceImportModal.vue?vue&type=script&lang=js&"
import style0 from "./SpaceImportModal.vue?vue&type=style&index=0&id=8b63cba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b63cba8",
  null
  
)

export default component.exports